// extracted by mini-css-extract-plugin
export var grid = "_b-5";
export var layout = "_b-0";
export var leftColumn = "_b-1";
export var leftInner = "_b-2";
export var rightColumn = "_b-3";
export var rightInner = "_b-4";